import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from '../components/useTable';
 
import { Dimmer } from '../components/spinner';
// import { formatMoneda } from '../util/varios';
import axios from "axios";
import moment from 'moment';

const CatalogoSolicitudTraslado = props => {
    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    // const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idaprobacion: ''
    });
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        {
          id: "1",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "CÓDIGO",
          textAlign: "center",
        },
        {
          id: "2",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "DESCRIPCIÓN",
          textAlign: "center",
        },
        {
          id: "3",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "FECHA",
          textAlign: "center",
        },
        {
          id: "4",
          backgroundColor: "rgba(5, 81, 130, 1)",
          color: "#ffffff",
          label: "MONTO",
          textAlign: "center",
        },
      ];
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idaprobacion.includes(target.value)
                            || x.concheque.toLowerCase().includes(target.value.toLowerCase())
                            || x.proveedor.toLowerCase().includes(target.value.toLowerCase())
                            || x.observacion.toLowerCase().includes(target.value.toLowerCase())
                            ) {
                            return x;
                        }
                    });
                }
            }
        })

    }
    const seleccionarRegistros = () => {
        let endpoint = `${op.conexion}/api/administracion/catalogoaprobtraslafondotercero?idefiscal=${idefiscal}&stat=${props.estatus}&desde=${props.desde}`;
        console.log(endpoint)
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {
                console.log(response.data)
                setRecords(response.data)
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        }).finally(() => {
            setActivate(false);
        })
    }
    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setValues({
            idmoneda: '',
            descripcion: '',
            simbolo: '',
            predeterminada: false,
            valormoneda: ''
        });
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }
    const seleccionarMoneda = () => {
        props.onHideAceptaCatalogo(values);
    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setValues(item);
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
            }}
        >
            <Modal.Header className='header-azulGradiant'>
                <h3>
                    Buscar.
                </h3>
                <a type='button' ref={btnCancela} 
                    onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="input-group input-group-sm mb-3 m-0 col-5">
                        <input type='text'
                            onChange={handleSearch} 
                            className="form-control rounded-pill search-input" />
                </div>
                <div className="col-12 m-0 p-0">
                    <TblContainer >
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: values.idaprobacion === item.idaprobacion ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "30px",
                        }}
                      >
                        {item.idaprobacion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "300px",
                        }}
                      >
                        {item.descripaprobacion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "50px",
                        }}
                      >
                        {moment.utc(item.fecha).format("DD/MM/YYYY")}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "50px",
                        }}
                      >
                        {moment.utc(item.fechaaprobacion).format("DD/MM/YYYY")}
                      </td>
                                    </tr>

                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                <button ref={btnAcepta} 
                    className="btn btn-sm btnPrimary-azulGradiant rounded" 
                    onClick={seleccionarMoneda}>
                    <i className="fas fa-check-circle"> Aceptar</i> 
                </button>
                <button ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn btn-sm btnSecondary-azulGradiant rounded">
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoSolicitudTraslado;